<div class="card-block filters">
    <div class="row d-flex">
        <div class="col-xs-3"></div>
        <div class="col-xs-2 date-range" [class.disabled]="!hasDate">
            <i class="fal fa-calendar"></i>
            <input *ngIf="!hasDate"
                    disabled
                    type="text"
                    placeholder="{{'All years' | translate}}"
                    class="date-range--column__datepicker" />
            <input *ngIf="hasDate"
                    [disabled]="!hasDate"
                    type="text" daterangepicker
                    [options]="dateRangeOptions"
                    (selected)="onDateInputChanged($event)"
                    class="date-range--column__datepicker" />
        </div>
        <div class="col-xs-2" [class.disabled]="!hasClinic">
            <mat-form-field class="filters--clinics mat-input-pill">
                <mat-select
                        [disabled]="!hasClinic"
                        (selectionChange)="onClinicChange($event.value)"
                        [placeholder]="'Select Clinic' | translate" required="required"
                        [(value)]="clinicId" [(ngModel)]="clinicId">
                    <mat-option selected [value]="0">
                        {{ 'All Clinics' | translate }}
                    </mat-option>
                    <mat-option *ngFor="let item of clinics" [value]="item['id']">
                        {{ item['name'] }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="form-group col-xs-1 filters--testdata" [class.disabled]="!hasTestData">
            <label class="label">{{ 'Display test data' | translate }}</label>
            <div class="">
                <mat-slide-toggle
                        [disabled]="!hasTestData"
                        [(ngModel)]="showTestData"
                        (change)="switchTestData()">
                </mat-slide-toggle>
            </div>
        </div>

        <div class="form-group col-xs-1 filters--export" *ngIf="exportable">
            <i class="fal fa-file-csv" title="{{ 'Export CSV' | translate }}" (click)="export()"></i>
        </div>
    </div>
</div>